<template>
  <div class="countdown">
    <div v-if="days" class="countdown__block">
      <div class="countdown__digit">{{ days }} Dias</div>
      <!-- <div class="countdown__text">Dias</div> -->
    </div>
    <div class="countdown__block">
      <div class="countdown__digit">{{ hours }} Hrs</div>
      <!-- <div class="countdown__text">Hrs</div> -->
    </div>
    <div class="countdown__block">
      <div class="countdown__digit">{{ minutes }} Min</div>
      <!-- <div class="countdown__text">Min</div> -->
    </div>
    <div class="countdown__block">
      <div class="countdown__digit">{{ seconds }} Seg</div>
      <!-- <div class="countdown__text">Seg</div> -->
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    date: null,
    campanha_id: Number,
  },
  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000),
      event: new Date(this.date),
      finish: false,
      moment: moment,
    }
  },
  mounted() {
    const _self = this
    window.setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000)
      const agora = moment(new Date())
      const dataFim = moment(this.date, 'YYYY-MM-DD H:mm')
      if (agora.diff(dataFim, 'minutes') >= 0) {
        _self.finish = true
        _self.$emit('onFinish', this.campanha_id)
      }
    }, 1000)
  },
  methods: {},
  computed: {
    secondCount() {
      return this.calculatedDate - this.now
    },
    calculatedDate() {
      return Math.trunc(Date.parse(this.event) / 1000) + 10800
    },
    seconds() {
      if (this.secondCount < 0) return 0
      return this.secondCount % 60
    },
    minutes() {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60) % 60
    },
    hours() {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60 / 60) % 24
    },
    days() {
      if (this.secondCount < 0) return 0
      return Math.trunc(this.secondCount / 60 / 60 / 24)
    },
  },
  filters: {
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString()
      }
      return value.toString()
    },
  },
  watch: {},
}
</script>
<style lang="scss">
.countdown {
  display: flex;
  justify-content: center;
  &__block {
    text-align: center;
    padding: 0px 15px;
    position: relative;
    &:first-child {
      padding-left: 0;
      .countdown__digit {
        &:before {
          display: none;
        }
      }
    }
    &:last-child {
      padding-right: 0;
    }
  }
  &__text {
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  &__digit {
    font-weight: bold;
    line-height: 1;
    margin-bottom: 5px;
    &:before {
      content: ':';
      position: absolute;
      left: -5px;
    }
  }
}
</style>
